import React from "react"
import { useTranslation } from "react-i18next"
import { Box, Typography, styled } from "@mui/material"
import { DebtType } from "types"

interface Props {
  debt: DebtType
}

const PaymentScheduleError = ({ debt }: Props) => {
  const { t } = useTranslation()

  return (
    <Container>
      <Title variant="h5">{t("features.payment_schedule.error.title")}</Title>
      {debt.manager && (
        <Typography variant="h6">
          {t("features.payment_schedule.error.phone", {
            phone: debt.manager.phone,
          })}
        </Typography>
      )}
      {debt.manager && (
        <Typography variant="h6">
          {t("features.payment_schedule.error.email", {
            email: debt.manager.email,
          })}
        </Typography>
      )}
    </Container>
  )
}

export default PaymentScheduleError

export const Container = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  maxWidth: "780px",
  margin: "24px auto 124px auto",
}))

const Title = styled(Typography)(() => ({
  marginBottom: "15px",
}))
